@import '@styles/typography.scss';
@import '@styles/colors.scss';
@import '@styles/mixins.scss';
@import '@styles/animations.scss';
@import '@styles/fonts.scss';

/* --------------------------------- Anatomy -------------------------------- */
.button {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  box-sizing: border-box;
  border: 1px solid transparent;
  border-radius: 100px;
  padding: 12px 32px;
  width: fit-content;
  color: var(--color-white);
  font-weight: 600;
  font-size: 1.125rem;
  letter-spacing: 0.025em;
  position: relative;
  overflow: hidden;
  @include font-absans;
}

.buttonContent {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 8px;
}

/* -------------------------------- Variants -------------------------------- */

.buttonPrimary {
  @include ai-gradient;
  background-clip: padding-box;
  z-index: 1;
  transition: transform 200ms ease-out, box-shadow 200ms ease-out, filter 200ms ease-out;

  :before {
    position: absolute;
    z-index: -1;
    transition: all 200ms ease-out;
    inset: 0;
    border-radius: 100px;
    background: radial-gradient(
      ellipse at center,
      rgba(255, 153, 102, 0.5),
      rgba(255, 153, 102, 0.3) 40%,
      transparent 70%
    );
    opacity: 0;
    content: '';
  }

  &:hover:not(:disabled) {
    transform: translateY(-2px) scale(1.02);
    box-shadow: 0 8px 24px rgba(255, 120, 80, 0.35), 0 4px 12px rgba(255, 153, 102, 0.25);
    filter: brightness(1.1);

    :before {
      opacity: 1;
    }
  }

  &:active:not(:disabled) {
    transform: translateY(0) scale(0.98);
    box-shadow: 0 2px 8px rgba(255, 120, 80, 0.3);
    filter: brightness(1.05);
  }
}

.buttonSecondary {
  @include ai-gradient-border;
  border: 2px solid transparent;
  border-radius: 100px;
  background-color: transparent;
  color: var(--color-white);
  transition: transform 200ms ease-out, box-shadow 200ms ease-out, filter 200ms ease-out;

  &:hover:not(:disabled) {
    transform: translateY(-2px) scale(1.02);
    box-shadow: 0 8px 24px rgba(255, 120, 80, 0.25), 0 4px 12px rgba(255, 153, 102, 0.15);
    filter: brightness(1.1);
  }

  &:active:not(:disabled) {
    transform: translateY(0) scale(0.98);
    box-shadow: 0 2px 8px rgba(255, 120, 80, 0.2);
  }
}

.buttonLight {
  border: 2px solid var(--color-light-grey);
}

.buttonLink {
  background-color: transparent;
  padding: 0;
  color: inherit;
  font: inherit;
  font-weight: 600;

  &:hover {
    text-decoration: underline;
  }
}

.buttonText {
  background-color: transparent;
  padding: 0;
  color: inherit;
  font: inherit;
  font-weight: inherit;
}

.buttonGhost {
  background-color: transparent;
  border: 1px solid var(--border-subtle, rgba(255, 255, 255, 0.1));
  color: var(--text-primary, var(--color-white));
  transition: all 0.3s ease;

  &:hover {
    background-color: var(--surface-overlay, rgba(255, 255, 255, 0.05));
    border-color: var(--accent-primary, var(--color-light-white));
  }
}

/* ---------------------------------- Sizes --------------------------------- */

.buttonSmall {
  padding: 0.5rem 0.75rem;
  font-size: 0.875rem;
}

.buttonMedium {
  padding: 0.75rem 1.5rem;
}

.buttonLarge {
  padding: 0.875rem 1.75rem;
  font-size: 1.125rem;
}

@media (max-width: 900px) {
  .buttonMedium {
    padding: 0.75rem 1.5rem;
    font-size: 0.875rem;
  }
}

/* ---------------------------------- States --------------------------------- */

.buttonPrimary:disabled {
  opacity: 0.5;
}

.buttonPrimary.buttonLoading {
  opacity: 1 !important;
}
